import { render } from "./InputNumber.vue?vue&type=template&id=79e4d549&scoped=true"
import script from "./InputNumber.vue?vue&type=script&lang=js"
export * from "./InputNumber.vue?vue&type=script&lang=js"

import "./InputNumber.vue?vue&type=style&index=0&id=79e4d549&scoped=true&lang=scss"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79e4d549"]])

export default __exports__